interface SpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

export const Spinner = ({ size = "md", className }: SpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl:  "h-32 w-32"
  };

  return (
    <div
      className={`animate-spin rounded-full border-2 border-violet-200 border-t-violet-500 ${sizeClasses[size]} ${className || ""}`}
    />
  );
};
